"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const getEnsuredProjectIdFromProcessor_1 = __importDefault(require("../getEnsuredProjectIdFromProcessor"));
const valueIsString_1 = __importDefault(require("../../typeAssertions/valueIsString"));
const updateAuthInfoBuilder = async ({ entryVars: { key, value, }, callbacks, functionId, processor, executeProcesses, }) => {
    try {
        const { currentUser } = processor.root.firebase.auth();
        if (!currentUser) {
            executeProcesses(functionId, callbacks.notLoggedIn, { message: 'No user logged in' });
        }
        else if (!(0, valueIsString_1.default)(key)) {
            executeProcesses(functionId, callbacks.error, `Invalid key to modify ${key}`);
        }
        else {
            if (!['name', 'phone', 'photoURL'].includes(key)) {
                throw new Error('You can only modify the name, phone and photoURL');
            }
            const appId = processor.root.getAppId();
            const projectId = (0, getEnsuredProjectIdFromProcessor_1.default)('updateAuthInfo', processor);
            if (!appId) {
                throw new Error('updateAuthInfoBuilder: No app id found');
            }
            const memberRef = processor.root.firebase.database()
                .ref(`projects/${projectId}/apps/${appId}/members/${currentUser.uid}`);
            const actualValue = value === undefined ? null : value;
            await memberRef.child(key).set(actualValue);
            await processor.root.loadFirebaseUserInfo();
            executeProcesses(undefined, callbacks.then);
        }
    }
    catch (error) {
        executeProcesses(functionId, callbacks.error, error);
    }
    executeProcesses(undefined, callbacks.finally);
};
exports.default = updateAuthInfoBuilder;
